
import  {
  VList,
  VTextField,
  VSwitch,
  VDatePicker,
  VSubheader,
  VApp,
  VFooter,
  VToolbar,
  VLayout,
  VIcon,
  VFlex,
  VMenu,
  VBtn,
  VProgressLinear
} from 'vuetify/lib'

const config = require(`themePath/config`)

export default {
  components : {
    VList,
    VTextField,
    VSwitch,
    VDatePicker,
    VSubheader,
    VApp,
    VFooter,
    VToolbar,
    VLayout,
    VIcon,
    VFlex,
    VMenu,
    VBtn,
    VProgressLinear
  },
  theme : {
    ...config.colors
  },
  options : {
    customProperties : true
  },
  iconfont : 'mdi'
}

